export const spacesToCamel = (s: string) =>
  s.replace(/(?:^\w|[A-Z]|\b\w)/g, (w, i) => (i === 0 ? w.toLowerCase() : w.toUpperCase())).replace(/\s+/g, '');

export const valueToOption = (value: string) => ({ value, label: value });

export const genLogger = (name: string) => ({
  trace: (...args: any[]) => console.trace(name, '-', ...args),
  error: (...args: any[]) => console.error(name, '-', ...args),
  warn: (...args: any[]) => console.warn(name, '-', ...args),
  log: (...args: any[]) => console.log(name, '-', ...args),
  info: (...args: any[]) => console.info(name, '-', ...args),
});
